import { render, staticRenderFns } from "./LoncengIcon.vue?vue&type=template&id=72d30a80"
import script from "./LoncengIcon.vue?vue&type=script&lang=js"
export * from "./LoncengIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports